// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageSelector__container {

}
.imageSelector__btn {
    height: 3rem;
    width: 100%;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
    text-transform: capitalize;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}`, "",{"version":3,"sources":["webpack://./src/components/ImageSelector/imageSelector.css"],"names":[],"mappings":"AAAA;;AAEA;AAEI;IAAA,YAA0F;IAA1F,WAA0F;IAA1F,uBAA0F;IAA1F,kBAA0F;IAA1F,4DAA0F;IAA1F,0BAA0F;IAA1F,uBAA0F;IAA1F,oBAA0F;IAA1F,mDAA0F;IAA1F,+EAA0F;IAA1F,mGAA0F;IAA1F;AAA0F","sourcesContent":[".imageSelector__container {\n\n}\n.imageSelector__btn {\n    @apply bg-gray-200 w-full h-12 rounded-md shadow-lg text-gray-500 capitalize tracking-wide; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
